import { render, staticRenderFns } from "./BuyTab3.vue?vue&type=template&id=fcb71fac&scoped=true&lang=pug&"
import script from "./BuyTab3.vue?vue&type=script&lang=js&"
export * from "./BuyTab3.vue?vue&type=script&lang=js&"
import style0 from "./BuyTab3.vue?vue&type=style&index=0&id=fcb71fac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb71fac",
  null
  
)

export default component.exports